import { Spinner } from "react-bootstrap";
// import StashItem from "../stash-item";
// import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, shallowEqual } from "react-redux";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import {
    callCancel,
    // getMediasSent,
    // getSoldPostMedias,
    getStash,
    setStashFilter,
    setStashHasMore,
    setStashMedias,
    setStashCurrentPage,
    setTempSelected,
    setStash,
} from "../../../../redux/actions/stash";
// import { trackWindowScroll } fro`    m 'react-lazy-load-image-component';
import VirtualizedGridList from "../../VirtualizedGridList";
import { resetStashMedias } from "../../../../redux/actions/stash";

const MediaList = ({
    show,
    busy,
    filter,
    hasMore,
    mediaFiles,
    maxSelection = 0,
    stashFilter,
    stashSidebar,
    source,
    resetPage = 0,
    currentPage,
    stashSelected,
    stash,
}) => {
    const stashMedia = useMemo(() => {
        return mediaFiles;
    }, [
        mediaFiles
    ]);

    const perPage = 30;
    const dispatch = useDispatch();
    // const [pageChange, setPageChange] = useState(0);

    // const observer = useRef();
    // const lastStashElementRef = useCallback(node => {
    //     if (busy) return;
    //     if (observer.current) {
    //         observer.current.disconnect();
    //     }

    //     observer.current = new IntersectionObserver(entries => {
    //         if (entries[0].isIntersecting && hasMore) {
    //             setCurrentPage(currentPage => currentPage + 1);
    //             setPageChange(pageChange => pageChange + 1);
    //         }
    //     });

    //     if (node) observer.current.observe(node);
    //     return () => {
    //         observer.current.disconnect();
    //     };
    // }, [busy, hasMore]);

    const changePage = (e) => {
        if (busy) {
            return '';
        }

        if (hasMore) {
            dispatch(setStashCurrentPage(currentPage + 1));
            // setPageChange(pageChange => pageChange + 1);
        }
    };

    const updateStashFilter = (filter) => {
        dispatch(callCancel());

        setTimeout(() => {
            dispatch(setStashFilter(filter));
        }, 300);
    };

    useEffect(() => {
        let mounted = true;

        if (!(currentPage === 1 && mediaFiles.length > 0)) {
            dispatch(getStash({
                per_page: perPage,
                page: currentPage,
                stash_filter: filter,
                needs_information: !stashSidebar
            }));
        }

        return () => {
            mounted = false;
        };
    // }, [pageChange]);
    }, [currentPage]);

    useDidMountEffect(() => {
        let mounted = true;

        dispatch(setStashMedias([]));
        dispatch(setStashHasMore(true));
        dispatch(setStashCurrentPage(1));

        const params = {
            per_page: perPage,
            page: 1,
            stash_filter: filter,
            reset: true,
            needs_information: !stashSidebar
        };
        dispatch(getStash(params));

        return () => {
            mounted = false;
        };
    }, [filter]);

    useEffect(() => {
        if (show) {
            const modal = document.querySelector('.modal');

            // document.body.style.overflow = "hidden";
            if (modal) {
                modal.style.overflow = 'hidden';
            }
        } else {
            // document.body.style.overflow = "auto";
        }

        return () => {
            // document.body.style.overflow = "auto";
        };
    }, [show]);

    useDidMountEffect(() => {
        dispatch(setStashCurrentPage(1));
    }, [resetPage]);

    useEffect(() => {
        dispatch(resetStashMedias());
        dispatch(getStash({ reset: true }));

        return () => {
            dispatch(setStashCurrentPage(1));
        }
    }, []);

    return <>
        <div className={`stash-header-filters`}>
            <ul>
                <li>
                    <span
                        onClick={() => updateStashFilter('all')}
                        data-title="all"
                        className={`${stashFilter == '' || stashFilter == 'all' ? 'active' : ''}`}
                    >All
                    </span>
                </li>
                <li>
                    <span
                        onClick={() => updateStashFilter('image')}
                        data-title="images"
                        className={`${stashFilter == 'image' ? 'active' : ''}`}
                    >Images
                    </span>
                </li>
                <li>
                    <span
                        onClick={() => updateStashFilter('video')}
                        data-title="videos"
                        className={`${stashFilter == 'video' ? 'active' : ''}`}
                    >Videos
                    </span>
                </li>
            </ul>
        </div>

        {
            busy && mediaFiles.length === 0 && <div className="preloading-container">
                <Spinner size="lg" animation="border" variant="primary" />
            </div>
        }

        {/* Spinner with existing medias */}
        {
            <div className="media_container" id="stash-cont">
                {
                    // mediaFiles && mediaFiles.hasOwnProperty('length') && mediaFiles.length > 0 && mediaFiles.map((k, index) => {
                    //     // +6 higher number can cause filter issues. Test images/videos tab when changed
                    //     return (mediaFiles.length === index + 6)
                    //         ? <StashItem
                    //             key={k.media_id}
                    //             item={k}
                    //             max={maxSelection}
                    //             source={source}
                    //             ref={lastStashElementRef}
                    //         />
                    //         : <StashItem
                    //             key={k.media_id}
                    //             item={k}
                    //             max={maxSelection}
                    //             source={source}
                    //         />;
                    // })
                    stashMedia.length > 0
                        ? <VirtualizedGridList
                            items={stashMedia}
                            maxSelection={maxSelection}
                            source={source}
                            changePage={changePage}
                            hasMore={hasMore}
                        />
                        : null
                }
                {/* {
                    busy && mediaFiles.length > 0 && <div className="text-center p4" style={{ display: 'block', width: '100%' }}>
                        <Spinner size="md" animation="border" variant="primary" />
                    </div>
                } */}
            </div>
        }
    </>;
};

const mapStateToProps = state => {
    return {
        show: state.stash.show,
        busy: state.stash.busy,
        filter: state.stash.filter,
        hasMore: state.stash.hasMore,
        mediaFiles: state.stash.medias,
        stashFilter: state.stash.filter,
        stashSidebar: state.stash.stashSidebar,
        currentPage: state.stash.currentPage,
        stashSelected: state.stash.stashSelected,
        stash: state.stash,
    };
};

export default connect(mapStateToProps, null, null, { areStatePropsEqual: shallowEqual })((MediaList));
